<template>
  <span>{{ fechaPeriodo }}</span>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "PeriodoComponent",
  computed: {
    fechaPeriodo() {
      if (this.params.data.periodo) {
        return this.$moment(this.params.data.periodo).format("MM/YYYY");
      }
      return "";
    },
  },
});
</script>
